<fsx-pdf-viewer
  *ngIf="pdfViewerParams | async as pdfViewerParams"
  [allowSidePanel]="false"
  [allowClose]="false"
  [pdfViewerParams]="pdfViewerParams"
  [zoom]="100"
></fsx-pdf-viewer>
